import React, { createContext } from 'react';

export const LangContext = createContext({ lang: 'is' });

export default ({ lang, children }) => <LangContext.Provider value={{ lang }}>{children}</LangContext.Provider>;
